import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from 'antd';
import React from 'react';

import { AntdUploadChildren } from '@/components/UI/AntdUploadChildren';
import { getPreviewImageUrl } from '@/helpers/handleAntdUploadPreviewFile';

import {
  EDUTAINMENT_CATEGORY_OPTIONS,
  PLAN_OPTIONS,
  TEACHER_OPTIONS,
} from './constants';
import {
  validateEnrollmentNumbers,
  validateEnrollmentTimeRange,
} from './helpers';
import styles from './index.module.scss';

const { Item, useFormInstance } = Form;
const { TextArea } = Input;

export const InformationSection = () => {
  const form = useFormInstance();

  const handleUploadRemove = () => {
    form.setFieldValue('image', null);
    return false;
  };

  return (
    <Space direction="vertical" className={styles.section}>
      <h4>育樂資訊</h4>
      <div className={styles.information}>
        <Space direction="vertical" className={styles.subContainer}>
          <Item
            label="育樂名稱"
            name="name"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <Input placeholder="例如：創意芳香手工皂" />
          </Item>
          <Item
            label="育樂類別"
            name="category"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <Select
              options={EDUTAINMENT_CATEGORY_OPTIONS}
              placeholder="請選擇類別"
            />
          </Item>
          <Item
            label="所屬計費方案"
            name="plans"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <Select
              allowClear
              showArrow
              mode="multiple"
              maxTagCount="responsive"
              options={PLAN_OPTIONS}
              placeholder="請選擇方案(多選)"
            />
          </Item>
          <Item
            label="講師"
            name="teacher"
            rules={[{ required: true, message: '必填欄位' }]}
          >
            <Select options={TEACHER_OPTIONS} placeholder="請選擇講師" />
          </Item>
          <Item
            label="育樂上限人數"
            name="maximumEnrollment"
            rules={[
              {
                required: true,
                validator: (_, maximumEnrollment) =>
                  validateEnrollmentNumbers({
                    isMinimum: false,
                    minimumEnrollment: form.getFieldValue('minimumEnrollment'),
                    maximumEnrollment,
                  }),
              },
            ]}
          >
            <InputNumber
              min={1}
              step={1}
              precision={0}
              placeholder="例如：1（不需輸入單位）"
              className={styles['w-full']}
            />
          </Item>
          <Item
            label="育樂最低人數"
            name="minimumEnrollment"
            rules={[
              {
                required: true,
                validator: (_, minimumEnrollment) =>
                  validateEnrollmentNumbers({
                    isMinimum: true,
                    minimumEnrollment,
                    maximumEnrollment: form.getFieldValue('maximumEnrollment'),
                  }),
              },
            ]}
          >
            <InputNumber
              min={1}
              step={1}
              precision={0}
              placeholder="例如：1（不需輸入單位）"
              className={styles['w-full']}
            />
          </Item>
          <div className={styles.enrollmentTimeRange}>
            <Item
              label="報名起始時間"
              name={['enrollment', 'startTime']}
              className={styles['flex-1']}
              rules={[
                {
                  required: true,
                  validator: (_, startTime) =>
                    validateEnrollmentTimeRange({
                      isStartTime: true,
                      startTime,
                      endTime: form.getFieldValue(['enrollment', 'endTime']),
                    }),
                },
              ]}
            >
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm"
                placeholder="請選擇起始時間"
                className={styles['w-full']}
              />
            </Item>
            <Item
              label="報名截止時間"
              name={['enrollment', 'endTime']}
              className={styles['flex-1']}
              rules={[
                {
                  required: true,
                  validator: (_, endTime) =>
                    validateEnrollmentTimeRange({
                      isStartTime: false,
                      startTime: form.getFieldValue([
                        'enrollment',
                        'startTime',
                      ]),
                      endTime,
                    }),
                },
              ]}
            >
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm"
                placeholder="請選擇截止時間"
                className={styles['w-full']}
              />
            </Item>
          </div>
        </Space>

        <Space direction="vertical" className={styles.subContainer}>
          <Item label="育樂介紹" name="description">
            <TextArea
              showCount
              autoSize={{ minRows: 4, maxRows: 6 }}
              maxLength={100}
              placeholder="例如：這是一個非常適合新手的課程，有系統性的介紹手工皂......"
            />
          </Item>
          <Item label="費用包含" name="includedPayment">
            <TextArea
              showCount
              autoSize={{ minRows: 4, maxRows: 6 }}
              maxLength={100}
              placeholder="例如：材料費......"
            />
          </Item>
          <Item label="注意事項" name="note">
            <TextArea
              showCount
              autoSize={{ minRows: 4, maxRows: 6 }}
              maxLength={100}
              placeholder="例如：每次上課無故遲到或無故早退者，視同缺席1次......"
            />
          </Item>
          <Item
            label="上傳圖片"
            name="image"
            valuePropName="fileList"
            getValueFromEvent={(e) => e.fileList}
          >
            <Upload
              accept="image/*"
              maxCount={1}
              listType="picture-card"
              beforeUpload={() => false}
              previewFile={getPreviewImageUrl}
              onRemove={handleUploadRemove}
            >
              <AntdUploadChildren />
            </Upload>
          </Item>
        </Space>
      </div>
    </Space>
  );
};
